import { BaseModel } from 'core/models/base.model.js';

/**
 * Model pour obtenir la valeur de Type de Gestion du collaborateur
 */
export var TypeGestionModel = BaseModel.extend({

  defaults: {
    "typegest": ""
  },

  url: function() {
    return Configuration.restRoot + "/rest/ficheperso/" + encodeURIComponent(this.collab) + "/typegest/" + encodeURIComponent(this.date);
  },

  initialize: function(options) {
    if (options && options.collab) {
      this.collab = options.collab;
    }
    if (options && options.date) {
      this.date = options.date;
    }
  }
});
